<template>
    <div class="flatPass-row objDots" v-if="value"><p :class="titleClass">{{ title }}<template  v-if="title == '' && titleComputed">{{titleComputed?titleComputed(value):value}}</template></p><span/><p class="text-right">{{ draw?draw(value):value}}</p></div>
</template>
<script>
    export default {
	    name: 'ReFlatRow',
        props:{
            value: {default:false},
            title: String, 
            titleComputed: Function,
            draw: Function,
            titleClass: {type:String, default:''}
        }
    }
</script>
<style lang="scss">
    .flatPass-row {
        display: flex; justify-content: space-between; margin-bottom: 5px;
        /*
        > *{flex:1;flex-grow:10;}
        > span{flex:10;flex-grow:1}
        */
    }
</style>
